import platform from "platform";
import { ADD_ANALYTICS } from "../storage/reducers/types";

export const REGISTRATION_PAGE_VIEW = "REGISTRATION_PAGE_VIEW";
export const REGISTRATION_LINK_CLICK = "REGISTRATION_LINK_CLICK";
export const SIGN_IN_LINK_CLICK = "SIGN_IN_LINK_CLICK";
export const REGISTRATION_SUCCESS = "REGISTRATION_SUCCESS";
export const REGISTRATION_FAILURE = "REGISTRATION_FAILURE";
export const VERIFY_EMAIL_PAGE_VIEW = "VERIFY_EMAIL_PAGE_VIEW";

export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAILURE = "VERIFY_EMAIL_FAILURE";
export const SIGN_IN_PAGE_VIEW = "SIGN_IN_PAGE_VIEW";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_IN_FAILURE = "SIGN_IN_FAILURE";
export const RESET_PASSWORD_LINK_CLICK = "RESET_PASSWORD_LINK_CLICK";
export const RESET_PASSWORD_PAGE_VIEW = "RESET_PASSWORD_PAGE_VIEW";
export const RESET_PASSWORD_EMAIL_SUBMIT_SUCCESS = "RESET_PASSWORD_EMAIL_SUBMIT_SUCCESS";
export const RESET_PASSWORD_EMAIL_SUBMIT_FAILURE = "RESET_PASSWORD_EMAIL_SUBMIT_FAILURE";
export const RESET_PASSWORD_CODE_SUBMIT_SUCCESS = "RESET_PASSWORD_CODE_SUBMIT_SUCCESS";
export const RESET_PASSWORD_CODE_SUBMIT_FAILURE = "RESET_PASSWORD_CODE_SUBMIT_FAILURE";
export const RESET_PASSWORD_NEW_PASSWORD_SUBMIT_SUCCESS = "RESET_PASSWORD_NEW_PASSWORD_SUBMIT_SUCCESS";
export const RESET_PASSWORD_NEW_PASSWORD_SUBMIT_FAILURE = "RESET_PASSWORD_NEW_PASSWORD_SUBMIT_FAILURE";

export const CREDENTIALS_PAGE_VIEW = "CREDENTIALS_PAGE_VIEW";
export const CREDENTIALS_GENERATE_SUCCESS = "CREDENTIALS_GENERATE_SUCCESS";
export const CREDENTIALS_GENERATE_FAILURE = "CREDENTIALS_GENERATE_FAILURE";
export const CREDENTIAL_COPY = "CREDENTIAL_COPY";
export const SECRET_ROTATION_START = "SECRET_ROTATION_START";
export const SECRET_ROTATION_PASSWORD_SUBMIT = "SECRET_ROTATION_PASSWORD_SUBMIT";
export const SECRET_ROTATION_PASSWORD_CANCEL = "SECRET_ROTATION_PASSWORD_CANCEL";
export const SECRET_ROTATION_PASSWORD_SUCCESS = "SECRET_ROTATION_PASSWORD_SUCCESS";
export const SECRET_ROTATION_PASSWORD_FAILURE = "SECRET_ROTATION_PASSWORD_FAILURE";
export const SECRET_ROTATION_NEW_SECRET_GENERATE_SUCCESS = "SECRET_ROTATION_NEW_SECRET_GENERATE_SUCCESS";
export const SECRET_ROTATION_NEW_SECRET_GENERATE_FAILURE = "SECRET_ROTATION_NEW_SECRET_GENERATE_FAILURE";
export const OLD_SECRET_DELETE_SUCCESS = "OLD_SECRET_DELETE_SUCCESS";
export const OLD_SECRET_DELETE_FAILURE = "OLD_SECRET_DELETE_FAILURE";

export const WEBHOOK_LIST_PAGE_VIEW = "WEBHOOK_LIST_PAGE_VIEW";
export const WEBHOOK_CREATE_PAGE_VIEW = "WEBHOOK_CREATE_PAGE_VIEW";
export const WEBHOOK_CREATE_SUCCESS = "WEBHOOK_CREATE_SUCCESS";
export const WEBHOOK_CREATE_FAILURE = "WEBHOOK_CREATE_FAILURE";
export const WEBHOOK_DELETE_CANCEL = "WEBHOOK_DELETE_CANCEL";
export const WEBHOOK_DELETE_SUCCESS = "WEBHOOK_DELETE_SUCCESS";
export const WEBHOOK_DELETE_FAILURE = "WEBHOOK_DELETE_FAILURE";
export const WEBHOOK_EDIT_PAGE_VIEW = "WEBHOOK_EDIT_PAGE_VIEW";
export const WEBHOOK_EDIT_CANCEL = "WEBHOOK_EDIT_CANCEL";
export const WEBHOOK_EDIT_SUCCESS = "WEBHOOK_EDIT_SUCCESS";
export const WEBHOOK_EDIT_FAILURE = "WEBHOOK_EDIT_FAILURE";

export const SIDEBAR_GO_LIVE_CLICK = "SIDEBAR_GO_LIVE_CLICK";

export const HELP_PAGE_VIEW = "HELP_PAGE_VIEW";
export const HELP_GO_LIVE_CLICK = "HELP_GO_LIVE_CLICK";
export const HELP_DISCORD_CLICK = "HELP_DISCORD_CLICK";
export const HELP_LINK_CLICK = "HELP_LINK_CLICK";
export const CONTEXT_HELP_CARD_CLICK = "CONTEXT_HELP_CARD_CLICK";
export const SCHEDULE_A_CALL_CLICK = "SCHEDULE_A_CALL_CLICK";
export const DISCORD_CLICK = "DISCORD_CLICK";
export const API_DOCS_CLICK = "API_DOCS_CLICK";
export const LOGOUT_CLICK = "LOGOUT_CLICK";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const FOOTER_LINK_CLICK = "FOOTER_LINK_CLICK";
export const EMAIL_SUPPORT_LINK_CLICKED = "EMAIL_SUPPORT_LINK_CLICKED";

export const VERIFY_EMAIL_RESEND_CLICK = "VERIFY_EMAIL_RESEND_CLICK";
export const VERIFY_EMAIL_RESEND_SUCCESS = "VERIFY_EMAIL_RESEND_SUCCESS";
export const VERIFY_EMAIL_RESEND_FAILURE = "VERIFY_EMAIL_RESEND_FAILURE";
export const RESET_PASSWORD_EMAIL_RESEND_CLICK = "RESET_PASSWORD_EMAIL_RESEND_CLICK";
export const RESET_PASSWORD_EMAIL_RESEND_SUCCESS = "RESET_PASSWORD_EMAIL_RESEND_SUCCESS";
export const RESET_PASSWORD_EMAIL_RESEND_FAILURE = "RESET_PASSWORD_EMAIL_RESEND_FAILURE";

export const GETTING_STARTED_PAGE_VIEW = "GETTING_STARTED_PAGE_VIEW";
export const GETTING_STARTED_STEP_1_CLICK = "GETTING_STARTED_STEP_1_CLICK";
export const GETTING_STARTED_STEP_2_CLICK = "GETTING_STARTED_STEP_2_CLICK";
export const GETTING_STARTED_ACCOUNT_CONNECT_SUCCESS = "GETTING_STARTED_ACCOUNT_CONNECT_SUCCESS";
export const GETTING_STARTED_STEP_3_DATA_LOAD = "GETTING_STARTED_STEP_3_DATA_LOAD";
export const GETTING_STARTED_VIEW_API_CREDENTIALS_CLICK = "GETTING_STARTED_VIEW_API_CREDENTIALS_CLICK";
export const GETTING_STARTED_DOCUMENTATION_CLICK = "GETTING_STARTED_DOCUMENTATION_CLICK";
export const ERROR_TIMEOUT_API_ACTIVATION_DELAY = "ERROR_TIMEOUT_API_ACTIVATION_DELAY";

export const ENVIRONMENT_CHANGED = "ENVIRONMENT_CHANGED";
export const COMPLIANCE_FORM_VIEW = "COMPLIANCE_FORM_VIEW";
export const COMPLIANCE_FORM_SUBMIT = "COMPLIANCE_FORM_SUBMIT";

// Creator Module
export const LINK_LANDING_PAGE_VIEW = "LINK_LANDING_PAGE_VIEW";
export const LINK_CREATE_INITIATED = "LINK_CREATE_INITIATED";
export const LINK_SENT_SUCCESS = "LINK_SENT_SUCCESS";
export const LINK_SENT_FAILED = "LINK_SENT_FAILED";
export const LINK_UPLOAD_CONTACTS = "LINK_UPLOAD_CONTACTS";
export const LINK_UPLOAD_CONTACTS_FAILED = "LINK_UPLOAD_CONTACTS_FAILED";
export const LINK_ALL_PAGE_VIEW = "LINK_ALL_PAGE_VIEW";
export const LINK_CONNECTED_ACCOUNT_PAGE_VIEW = "LINK_CONNECTED_ACCOUNT_PAGE_VIEW";
export const LINK_FAILED_ACCOUNT_PAGE_VIEW = "LINK_FAILED_ACCOUNT_PAGE_VIEW";
export const COPY_INVITE_LINK = "COPY_INVITE_LINK";
export const RESEND_INVITE_LINK = "RESEND_INVITE_LINK";
export const LINK_SEARCH_INITIATED = "LINK_SEARCH_INITIATED";
export const PROFILE_PAGE_VIEW = "PROFILE_PAGE_VIEW";
export const CONTENT_ITEM_CLICKED = "CONTENT_ITEM_CLICKED";
export const EXPORT_PROFILE_CLICKED = "EXPORT_PROFILE_CLICKED";
export const CONTENT_THUMBNAIL_EXPIRED = "CONTENT_THUMBNAIL_EXPIRED";

export const trackEvent = (eventName, eventObj = {}) => {
  const analytics = JSON.parse(localStorage.getItem("phyllo_analytics"));
  const eventToSend = { ...eventObj, ...analytics };
  window.analytics.track(eventName, eventToSend);
};
export const logUser = (userId, userObj) => {
  window.analytics.identify(userId, userObj);
};
// page
export const changePage = (page, params = {}) => {
  window.analytics.page(page, params);
};

export const updateAnalyics = async (userProfile, dispatchAnalytics, environment) => {
  try {
    const deviceLocale = window.navigator.languages;
    const browserLocale = window.navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
    const { userAgent } = window.navigator;
    const {
      product,
      manufacturer,
      os: { family: deviceOs },
      os: { version: deviceOsVersion },
    } = platform;
    const { name: browser, version: browserVersion } = platform.parse(userAgent);
    let IPAddress;
    try {
      const res = await fetch("https://geolocation-db.com/json/");
      const response = await res.json();
      IPAddress = response?.IPv4;
    } catch (e) {
      IPAddress = "Not found";
    }
    const analyticsPayload = {
      environment: environment,
      device_manufacturer: manufacturer,
      device_name: product,
      device_model: product,
      device_os: deviceOs,
      device_os_version: deviceOsVersion,
      device_locale: deviceLocale,
      device_language: window.navigator.languages,
      device_timezone: Intl.DateTimeFormat()?.resolvedOptions()?.timeZone,
      device_dimensions_width: window.screen.width,
      device_dimensions_height: window.screen.height,
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      ip_address: IPAddress,
      network_type: navigator?.connection?.effectiveType,
      browser_name: browser,
      browser_version: browserVersion,
      browser_locale: browserLocale,
      browser_user_agent: userAgent,
      // tenant_id: "",
      // tenant_name: userProfile && userProfile.user.firstName + " " + (userProfile.user.lastName ? userProfile.user.lastName : ""),
      user_id: userProfile.user.email,
      user_email: userProfile.user.email,
    };
    dispatchAnalytics({ type: ADD_ANALYTICS, payload: analyticsPayload });
  } catch (e) {
    console.log(e);
  }
};
